import { FormInstance } from 'antd/lib/form';
import _ from 'lodash';

export const on_change = _.debounce(
  async (form: FormInstance | undefined, set_disabled: React.Dispatch<React.SetStateAction<boolean>>, special_field_error?: boolean) => {
    try {
      if (form) {
        await form.validateFields();
        set_disabled(!!special_field_error);
      }
    } catch (err) {
      set_disabled(true);
    }
  },
  250
);
